<template>
  <v-card light>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      {{ user.email }} - {{ user.role }}
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>

    <v-card-text>
      <div justify="center" align="center" class="mb-4">
        <v-avatar color="primary" class="ma-6">
          <v-icon dark>mdi-account-circle</v-icon>
        </v-avatar>
        <!--   <v-btn @click="openAvatarPicker">Change Avatar</v-btn> -->
      </div>

      <v-text-field v-model="user.firstName" label="FirstName"></v-text-field>
      <v-text-field v-model="user.lastName" label="Last Name"></v-text-field>
      <v-text-field v-model="user.email" label="Email Address"></v-text-field>
      <v-text-field
        disabled
        v-if="user.dateLastConnexion"
        v-model="$moment(user.dateLastConnexion).format('DD-MM-YYYY HH:mm:ss')"
        label="Date de dernière connexion"
      ></v-text-field>
      <div>DB Utilisé : {{ bytesToSize(dbSize.usage) }}</div>
      <div>DB Disponible : {{ bytesToSize(dbSize.quota) }}</div>

      <!--  <div>Local Storage utilisé : {{ localStorageSize }}</div>
      <div>Local Storage Disponible : 10 MB</div> -->
    </v-card-text>
    <v-card-actions>
      <template>
        <v-item-group>
          <v-container>
            <v-row>
              <v-item v-if="online">
                <v-col>
                  <v-card class="neumorphicCard transparent" flat dark>
                    <v-card-text>
                      <div justify="center" align="center">
                        <v-expansion-panels light flat="">
                          <v-expansion-panel>
                            <v-expansion-panel-header
                              justify="center"
                              align="center"
                              expand-icon="mdi-menu-down"
                            >
                              <template v-slot:actions>
                                <v-icon color="primary">$expand</v-icon>
                              </template></v-expansion-panel-header
                            >
                            <v-expansion-panel-content>
                              <div>
                                <!--   <v-btn class="error" rounded @click="goToLogin"
                                  >Se reconnecter
                                  <v-icon right dark
                                    >mdi-exit-to-app</v-icon
                                  ></v-btn
                                > -->

                                <v-btn
                                  class="warning my-4"
                                  rounded
                                  @click="userLogOut"
                                  >Se déconnecter
                                  <v-icon right dark
                                    >mdi-exit-to-app</v-icon
                                  ></v-btn
                                >
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-item>
              <v-item>
                <v-col>
                  <v-card class="neumorphicCard transparent">
                    <v-card-text>
                      <div class="caption grey--text">Version</div>
                      <div>{{ metadata.build }}</div>
                      <div class="caption grey--text">Date</div>
                      <div>{{ metadata.date }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-item>
            </v-row></v-container
          ></v-item-group
        >
      </template>
    </v-card-actions>
    <Navigation v-if="isAdmin" :elements="AdminNavigation" />
    <Navigation v-if="isGroupe" :elements="GroupeNavigation" />
    <Navigation v-if="isSuperviseur" :elements="SuperviseurNavigation" />
    <!--   {{ user }} -->
  </v-card>
</template>

<script>
import metadata from "@/metadata.json";
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.metadata.build = metadata.build;
    this.metadata.date = metadata.date;
    this.getindexedDbSize();
    this.setLocalStorageSize();
  },
  data() {
    return {
      dbSize: "",

      metadata: {
        time: "",
        build: "",
        version: "",
        date: "",
      },
    };
  },
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    ...mapActions({
      userLogOut: "Auth/userSignOut",
      setLocalStorageSize: "Utils/setLocalStorageSize",
    }),
    goToLogin() {
      this.$confirm(
        "Voulez vous vraiment vous reconnecter, cela va vous déconnecter définitivement ?"
      ).then((res) => {
        if (res) {
          this.$router.push("/Login");
        }
      });
    },

    getindexedDbSize() {
      let self = this;
      navigator.storage.estimate().then((data) => {
        self.dbSize = data;
      });
    },

    bytesToSize(bytes) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "n/a";
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      if (i === 0) return `${bytes} ${sizes[i]})`;
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
    },
  },
  computed: {
    ...mapState({
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
      GroupeNavigation: (state) => state.Navigation.GroupeNavigation,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      isAuthenticated: (state) => state.Auth.isAuthenticated,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isGroupe: (state) => state.Auth.isGroupe,
      user: (state) => state.Auth.user,
      online: (state) => state.Online.online,
      localStorageSize: (state) => state.Utils.localStorageSize,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
